import { FormControl, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import React from 'react';

import { useActivePractice } from '../../../../../context/ActivePracticeContext';

/**
 * HA-320: header dropdown that lets a multi-practice patient switch the
 * practice their data is scoped to. Renders nothing unless the caller has
 * at least two connected practices, so it is invisible for single-practice
 * patients and for non-Client users (who never fetch practices).
 */
export const PracticeSwitcher: React.FC = () => {
  const { activePractices, currentPracticeId, setCurrentPractice } = useActivePractice();

  if (activePractices.length <= 1) {
    return null;
  }

  const handleChange = (event: SelectChangeEvent) => {
    setCurrentPractice(event.target.value);
  };

  return (
    <FormControl size="small" sx={{ minWidth: 160, mr: 1 }}>
      <Select
        value={currentPracticeId ?? ''}
        onChange={handleChange}
        inputProps={{ 'aria-label': 'Practice' }}
        data-testid="practice-switcher"
        sx={{ fontSize: '0.875rem' }}
      >
        {activePractices.map((practice) => (
          <MenuItem key={practice.practiceId} value={practice.practiceId}>
            {practice.displayName}
            {practice.isPrimary ? ' (Primary)' : ''}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default PracticeSwitcher;
